<template>
  <div style="margin:20px">
    <div v-if="!standalone" style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Bus Tracker</span><br/>
      <span style="font-style: italic; font-size: 18px">view real-time bus status information</span>
    </div>
    <div style="background-color: white !important; border: none;">
      <div :style="isMobile() ? 'width:350px; background-color: white; border: none;' : 'width:430px; float: left; background-color: white; border: none;'" class="d-flex align-items-center justify-content-center">
        <table border="0">
        <tr>
          <td align="left" class="d-flex align-items-center justify-content-center">
            <table :style="isMobile() ? 'width:350px' : 'width:430px'">
              <tr>
                <td style="font-weight: bold; padding-bottom: 20px" colspan="2">For updated bus status information, follow these steps:</td>
              </tr>
              <tr>
                <td style="font-weight: bold">Departure Date</td><td align="left" style="position: relative" class="d-flex align-items-center justify-content-left">
                <date-picker v-model="departure_date" :config="options" :placeholder="departure_date"/>
              </td>
              </tr>
              <tr>
                <td style="font-weight: bold">Leaving From:</td>
                <td align="left" height="50px" >
                  <b-form-select v-if="departing_from || departure_options.length > 0" v-model="departing_from" :options="departure_options" />
                  <span v-else><b-spinner style="width: 1.2rem; height: 1.2rem;" label="Loading..."></b-spinner></span>
                </td>
              </tr>
              <tr v-if="arrival_options.length > 0 && arrival_options.length > 5">
                <td style="font-weight: bold">Going To:</td><td align="left" height="50px"><b-form-select v-model="arriving_at" :options="arrival_options"/></td>
              </tr>
              <tr v-if="time_options.length > 0 && arrival_options.length > 5">
                <td style="font-weight: bold">Time:</td><td align="left" height="50px"><b-form-select v-model="departure_time" :options="time_options"/></td>
              </tr>
              <tr v-if="arrival_table.length > 0 && arrival_table.length <= 5">
                <td style="font-weight: bold">Going To:</td>
                <td align="left">
                  <table width="100%" style="margin-top: 10px; font-weight: bold" cellspacing="5px" cellpadding="8px" border="1px dashed">
                    <template v-for="arrival_rec in arrival_table">
                      <tr v-for="time in arrival_rec.times" v-on:click.prevent="load_arrival_status(arrival_rec.arrive,time)">
                        <td :class="(arriving_at == arrival_rec.arrive && departure_time == time) ? 'arr-selected': ''">
                          {{arrival_rec.arrive}}
                        </td>
                        <td :class="(arriving_at == arrival_rec.arrive && departure_time == time) ? 'arr-selected': ''">
                          {{time}}
                        </td>
                      </tr>
                    </template>
                  </table>
                </td>
              </tr>
              <tr v-if="tracking_results">
                <td colspan="2"><hr/></td>
              </tr>
              <tr v-if="tracking_results">
                <td colspan="2" valign="top" align="left" style="margin: 2px; border:1px dotted" >
                  <table cellpadding="4px" width="100%">
                    <tr>
                      <td style="font-weight: bold">Schedule:</td>
                      <td v-if="user.role == 'admin'" align="left"><a target='_blank' :href="'https://cloud.samsara.com/o/' + summary.org_id + '/fleet/dispatch/v2?q=' + tracking_results.route">{{tracking_results.route}}</a></td>
                      <td v-else align="left">{{tracking_results.route}}</td>
                      <td v-if="!isMobile() && tracking_results.last_gps_time" align="right" style="font-style: italic; font-size: 14px; font-weight: bold">Last Update: {{tracking_results.last_gps_time}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold">Bus #:</td>
                      <td align="left" colspan="2">{{tracking_results.vehicle}}</td>
                    </tr>
                    <tr>
                      <td valign="top" style="font-weight: bold">Departure:</td>
                      <td align="left" colspan="2">
                        {{tracking_results.depart_time}}
                        <span style="font-style: italic" v-if="tracking_results.calc_dep_time">&nbsp;({{tracking_results.calc_dep_time}})</span>
                        <br/>
                        <span v-if="tracking_results.departure_status && tracking_results.departure_status.indexOf('Late') != -1" style="font-weight: bold; color:#EF4053;">{{tracking_results.departure_status}}</span>
                        <span v-else-if="tracking_results.departure_status && tracking_results.departure_status.indexOf('Early') != -1" style="font-weight: bold; color:#61B662;">{{tracking_results.departure_status}}</span>
                        <span v-else-if="tracking_results.departure_status" style="font-weight: bold">{{tracking_results.departure_status}}</span>
                      </td>
                    </tr>
                    <tr>
                      <td valign="top" style="font-weight: bold">Arrival:</td>
                      <td align="left" colspan="2">
                        {{tracking_results.arrive_time}}
                        <span style="font-style: italic" v-if="tracking_results.calc_arr_time">&nbsp;({{tracking_results.calc_arr_time}})</span>
                        <br/>
                        <span v-if="tracking_results.arrival_status && tracking_results.arrival_status.indexOf('Late') != -1" style="font-weight: bold; color:#EF4053;">{{tracking_results.arrival_status}}</span>
                        <span v-else-if="tracking_results.arrival_status && tracking_results.arrival_status.indexOf('Early') != -1" style="font-weight: bold; color:#61B662;">{{tracking_results.arrival_status}}</span>
                        <span v-else-if="tracking_results.arrival_status" style="font-weight: bold">{{tracking_results.arrival_status}}</span>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr v-if="!tracking_results && !loading" style="height: 400px">
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr v-if="!loading && departure_time">
                <td>&nbsp;</td>
                <td style="padding-top: 15px" align="right"><b-button style="background-color: steelblue; font-weight: bold; font-size: 18px;" v-on:click.prevent="load_status(true)">Refresh Status</b-button></td>
              </tr>
              <tr v-if="loading && departure_time" style="height: 100px">
                <td colspan="2" align="right">
                  <b-spinner style="margin-right: 20px; width: 2.5rem; height: 2.5rem;" label="Loading..."/>
                </td>
              </tr>
            </table>
          </td>
          </tr>
        </table>
      </div>
      <div :style="isMobile() ? 'background-color: white !important; border: none; width:350px': 'float: right; width:350px; background-color: white !important; border: none'">
          <div v-if="map_loaded" style="margin: 0px">
            <div style="border: none; padding-right:0px !important; padding-left:0px !important">
              <GmapMap id="map" ref="mapRef"
                       :zoom="zoom"
                       :center="center"
                       :options="mapStyle"
                       style="width:100%;  height: 500px;"
              >
                <GmapMarker
                    v-for="(marker,idx) in markers"
                    :position="marker.position"
                    :title="marker.title"
                    :label="marker.label"
                    :draggable="false"
                    :clickable="true"
                    :icon="marker.icon"
                />
              </GmapMap>
            </div>
          </div>
        </div>
      <br clear="left"/>
    </div>
  </div>
</template>
<script>
import {get_bus_tracker_results, get_bus_tracker_status} from '../networking/apis'
import moment from "moment";
import {justDate} from "../helpers/dates";
import {mapState} from "vuex";

export default {
  name: 'bus_tracker',
  components: {
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      summary: {},
      tenant_id: null,
      departure_date: justDate(moment()),
      tracking_results: null,
      departing_from: null,
      map_loaded: false,
      arriving_at: null,
      departure_time: null,
      results_hash: null,
      route_name: null,
      time_options: [],
      departure_options: [],
      arrival_options: [],
      arrival_table: [],
      items: [],
      tenant_type: 'CM',
      loading: false,
      standalone: false,
      center: null,
      zoom: null,
      markers: [],
      markers_full: [],
      bounds: null,
      infoWindow: {
        position: {lat: 0, lng: 0},
        open: false,
        template: ''
      },
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment(justDate(moment()),'MM-DD-YYYY').subtract(1, 'days'),
        maxDate: moment(justDate(moment()),'MM-DD-YYYY').add(1, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },
      mapStyle: {
        styles: [
          {
            "featureType": "landscape",
            "stylers": [
              { "color": "#F3F4F9" }
            ]
          },          {
            "featureType": "water",
            "stylers": [
              { "color": "#C1CDE4" }
            ]
          },
          {
            "featureType": "landscape.natural.terrain",
            "stylers": [
              { "color": "#E0EDCA" }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [{color: '#DDDDDD'}]
          },
          {
            featureType: 'road',
            elementType: 'geometry.fill',
            stylers: [{color: '#FFFFFF'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [{color: '#FEF8D6'}]
          },
          {
            featureType: 'transit',
            stylers: [{"visibility": "off"}]
          },
          {
            featureType: 'poi',
            stylers: [{"visibility": "off"}]
          },
        ]
      }
    }
  },
  async created() {
    await this.check_features()
  },
  methods: {
    async check_features() {

      if (this.$route.path.indexOf('/bus-tracker/') == -1) {
        this.standalone = false
        this.tenant_id = this.user.tenant
      }
      else {
        this.tenant_id = this.$route.path.split('/bus-tracker/')[1]
        this.standalone = true
      }

      this.load_data(false)
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    async load_data(load_map) {

      if (load_map) {
        this.loading = true
      }

      this.items = []
      try {
        let results = null;
        const departureDateFormatted = moment(this.departure_date, 'MM-DD-YYYY')
        if (!departureDateFormatted.isValid()) return
        results = await get_bus_tracker_results(this.tenant_id, departureDateFormatted.format('YYYY-MM-DD'))
        const {value: { data = [] } } = results
        this.summary = data.summary
        this.departure_options = data.summary.depart_list
      } catch(e) {
        this.alert = {show: true, message: "error retrieving data, try again later or contact support if needed" + e, variant: 'danger'}
      }
    },
    async load_arrival_status(arriving_at,time) {
      //console.log("load_arrival_status: " + arriving_at + ":" + time)
      this.arriving_at = arriving_at
      this.departure_time = time
      await this.sleep(500)
      await this.load_status(false)
    },
    async load_status(force) {

      if (!this.route_name) {
        //console.log("skipping - no route name: " + new_hash)
        return;
      }

      let new_hash = this.route_name + ":" + this.departure_time + ":" + this.departing_from + ":" + this.arriving_at;

      //console.log("load_status: " + new_hash)

      if (!force && this.results_hash && this.results_hash == new_hash) {
        //console.log("skipping - same result hash: " + new_hash)
        return
      }

      this.results_hash = new_hash

      this.loading = true
      this.items = []
      
      try {
        let results = null;

        const departureDateFormatted = moment(this.departure_date, 'MM-DD-YYYY')
        if (!departureDateFormatted.isValid()) return
        results = await get_bus_tracker_status(this.tenant_id, departureDateFormatted.format('YYYY-MM-DD'), this.route_name, this.departure_time, this.departing_from, this.arriving_at)

        const {value: { data = [] } } = results

        this.tracking_results = data.results
        this.markers = []

        if (this.tracking_results.depart_lat) {
          let position = {
            lat: Number(this.tracking_results.depart_lat),
            lng: Number(this.tracking_results.depart_lon),
          };

          this.markers.push({
            position: position,
            heading: 0,
            title: this.tracking_results.depart,
            label: {text: this.tracking_results.depart, className: 'map-label'},
            icon: this.mapSymbol("green")
          });
        }

        if (this.tracking_results.arrive_lat) {
          let position = {
            lat: Number(this.tracking_results.arrive_lat),
            lng: Number(this.tracking_results.arrive_lon),
          };

          this.markers.push({
            position: position,
            heading: 0,
            title: this.tracking_results.arrive,
            label: {text: this.tracking_results.arrive, className: 'map-label'},
            icon: this.mapSymbol("red")
          });

          this.center = position;
        }

        if (this.tracking_results.gps_track) {
          for (var i = 0; i < this.tracking_results.gps_track.length; i++) {
            var track = this.tracking_results.gps_track[i];

            let position = {
              lat: Number(track.lat),
              lng: Number(track.lng),
            };

            if (i == (this.tracking_results.gps_track.length - 1)) {
              this.center = position;

              this.markers.push({
                position: position,
                heading: track.headingDegrees,
                title: this.tracking_results.vehicle,
                label: {text: this.tracking_results.vehicle, className: 'veh-label'},
                icon: this.arrowSymbol(track)
              });

            } else {
              this.markers.push({
                position: position,
                heading: 0,
                //title: this.tracking_results.time,
                icon: this.trackSymbol(track)
              });
            }
          }
        }

        this.zoom = 9
        this.map_loaded = true
        this.loading = false

        if (this.markers.length > 1)
          await this.fitMapToMarkers()

        this.markers_full = this.markers
        this.loading = false

      } catch(e) {
        this.alert = {show: true, message: "error retrieving data, try again later or contact support if needed" + e, variant: 'danger'}
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async fitMapToMarkers() {
      if (!this.$refs.mapRef) {
        let cnt=0;
        while(cnt<10) {
          if (this.$refs.mapRef)
            break;
          await this.sleep(500);
          console.log("waiting for mapref: " + cnt)
          cnt++;
        }
      }

      this.bounds = new google.maps.LatLngBounds();
      this.bounds.extend(this.markers[0].position);
      this.bounds.extend(this.markers[1].position);

      this.$refs.mapRef.$mapObject.fitBounds(this.bounds);
    },
    trackSymbol(loc) {
      return {
        path: "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0",
        scale: .5,
        strokeColor: "steelblue",
        fillColor: "steelblue",
        fillOpacity: .5
      }
    },
    arrowSymbol(loc) {
      return {
        path: (loc.speedMilesPerHour == 0 || loc.headingDegrees == 0) ? "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0" : "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
        scale: 1.5,
        strokeColor: "white",
        strokeStyle: "bold",
        fillColor: loc.speedMilesPerHour == 0 ? "darkred" : "#29C68A",
        fillOpacity: 1,
        rotation: Number(loc.headingDegrees)
      }
    },
    mapSymbol(color) {
      return {
        path: "M-1.547 12l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM0 0q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
        fillColor: color,
        fillOpacity: 0.6,
        strokeWeight: 0,
        rotation: 0,
        scale: 1.5,
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
    },
    departure_date(target_from_date) {
      //console.log("departure_date: " + target_from_date)
      this.departure_date = target_from_date
      this.tracking_results = null
      this.departing_from = null
      this.arriving_at = null
      this.departure_time = null
      this.tracking_results = null
      this.items = []
      this.markers = []
      this.departure_options = []
      this.arrival_options = []
      this.time_options = []
      this.load_data(false)
    },
    departing_from(departing_from) {
      //console.log("departing_from:" + departing_from)
      this.tracking_results = null
      this.markers = []
      this.arriving_at = null
      this.departure_time = null
      this.items = []
      this.arrival_options = []
      this.arrival_table = []
      this.time_options = []
      let arr_locs = this.summary.depart_map[this.departing_from]
      for (let i in arr_locs) {
        this.arrival_options.push({'value': arr_locs[i], 'text': arr_locs[i].substring(0, 30)})
      }

      if (this.arrival_options.length == 1) {
        this.arriving_at = this.arrival_options[0].value
      }

      for (let depart_rec in this.summary.depart_times) {
        if (depart_rec.startsWith(this.departing_from))
          this.arrival_table.push({'arrive': depart_rec.split(":")[1], 'times': this.summary.depart_times[depart_rec]})
      }

    },
    arriving_at(arriving_at) {
      //console.log("!arriving at:" + arriving_at)
      this.tracking_results = null
      this.time_options = []
      this.markers = []
      this.items = []
      let dep_times = this.summary.depart_times[this.departing_from + ':' + this.arriving_at]
      for (let i in dep_times) {
        this.time_options.push({'value': dep_times[i], 'text': dep_times[i]})
      }

      if (this.time_options.length==1) {
        if (this.departure_time == this.time_options[0].value) {
          //console.log("!arriving at:load_status" + arriving_at)
          this.route_name = this.summary.route_map[this.departing_from + ':' + this.arriving_at + ':' + this.departure_time]
          this.load_status(false)
        }
        this.departure_time = this.time_options[0].value
      } else {
        this.departure_time = null
      }
    },
    departure_time(departure_time) {
      //console.log("!departure_time: " + departure_time)
      if (this.departure_time != null) {
        //console.log("!departure_time:load_status: " + departure_time)
        this.route_name = this.summary.route_map[this.departing_from + ':' + this.arriving_at + ':' + this.departure_time]
        this.load_status(false)
      }
    }

  }
}
</script>
<style scope>

.map-label {
  opacity: 0.8;
  font-size: 12px;
  bottom: 13px;
  position: relative;
  border: 1px solid black;
  background-color: #333;
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}

.veh-label {
  opacity: 0.8;
  font-size: 12px;
  bottom: 30px;
  position: relative;
  border: 1px solid black;
  background-color: #333;
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}

.arr-selected {
  background-color: rgba(70,130,180,.1);
}
</style>